import { render, staticRenderFns } from "./OrderFailed.vue?vue&type=template&id=4ae9a86f&scoped=true"
import script from "./OrderFailed.vue?vue&type=script&lang=js"
export * from "./OrderFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9a86f",
  null
  
)

export default component.exports